'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _ReactIframeResizerSuper = require('../external/ReactIframeResizerSuper');
var _ReactIframeResizerSuper2 = _interopRequireDefault(_ReactIframeResizerSuper);
var _reactI18next = require('react-i18next');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  infoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '800px',
    padding: '3rem',
    backgroundColor: '#d8dada'
  }
};
var Iframe = function (_Component) {
  _inherits(Iframe, _Component);
  function Iframe() {
    _classCallCheck(this, Iframe);
    return _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).apply(this, arguments));
  }
  _createClass(Iframe, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        otherProperties = _props.otherProperties,
        t = _props.t,
        classes = _props.classes;
      var iframeSrc = otherProperties.iframeSrc;
      var iframeResizerOptions = {
        checkOrigin: false,
        inPageLinks: true
      };
      return _react2.default.createElement('div', null, !!iframeSrc ? _react2.default.createElement(_ReactIframeResizerSuper2.default, {
        iframeResizerOptions: iframeResizerOptions,
        iframeResizerUrl: false,
        src: iframeSrc
      }) : _react2.default.createElement('div', {
        className: classes.infoWrapper
      }, _react2.default.createElement('p', null, t('text.no_iframe_src'))));
    }
  }]);
  return Iframe;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(Iframe));